export const SEO_SITE_NAME = "CORE Strategies PT";
export const SEO_CANONICAL_ORIGIN = "https://www.coreptkc.com";
export const SEO_DEFAULT_DESCRIPTION = "One-on-one physical therapy and movement guidance in Overland Park, Kansas, from CORE Strategies PT—serving the community since 2007.";
export const SEO_DEFAULT_IMAGE = "/manus-storage/core-pt-provider-50plus-hero_8d309f52.webp";

export type StaticSeoEntry = {
  title: string;
  description: string;
  canonicalPath: string;
  ogImage?: string;
  ogImageWidth?: number;
  ogImageHeight?: number;
  ogImageAlt?: string;
  noindex?: boolean;
};

export const STATIC_SEO: Record<string, StaticSeoEntry> = {
  "/": {
    title: "Physical Therapy in Overland Park, KS | CORE Strategies PT",
    description: "Move with more confidence through one-on-one physical therapy in Overland Park, KS. CORE Strategies PT builds thoughtful care around your goals.",
    canonicalPath: "/",
    ogImage: SEO_DEFAULT_IMAGE,
    ogImageWidth: 1400,
    ogImageHeight: 1100,
    ogImageAlt: "A physical therapist guiding shoulder movement with an active woman over 50 during a one-on-one session",
  },
  "/services": {
    title: "Physical Therapy Services in Overland Park, KS | CORE Strategies PT",
    description: "Explore one-on-one physical therapy, manual therapy, dry needling, BFR, Pilates, telehealth, injury prevention, and movement care in Overland Park.",
    canonicalPath: "/services",
  },
  "/vitality-class": {
    title: "Vitality Program | Fitness Classes for Adults 50+ in Overland Park",
    description: "Discover Vitality, a supportive fitness experience for adults 50+ who want to build strength, balance, confidence, and options for how they age.",
    canonicalPath: "/vitality-class",
    ogImage: "/manus-storage/core-vitality-step-up-clinic-nobars_e8f21156.webp",
    ogImageWidth: 1600,
    ogImageHeight: 1280,
    ogImageAlt: "An active woman in her 60s performing a controlled step-up exercise with a supportive coach nearby",
  },
  "/our-team": {
    title: "Physical Therapy Team in Overland Park, KS | CORE Strategies PT",
    description: "Meet the physical therapists and office professionals at CORE Strategies PT, a collaborative Overland Park practice serving the community since 2007.",
    canonicalPath: "/our-team",
  },
  "/patient-resources": {
    title: "Physical Therapy FAQs & Patient Resources | CORE Strategies PT",
    description: "Get answers about referrals, insurance, your first physical therapy visit, one-on-one care, session length, the exercise app, and next steps.",
    canonicalPath: "/patient-resources",
  },
  "/blog": {
    title: "Physical Therapy & Movement Blog | CORE Strategies PT",
    description: "Read the preserved CORE Strategies PT archive on movement, exercise, rehabilitation, injury prevention, sports performance, and active living.",
    canonicalPath: "/blog",
  },
  "/contact": {
    title: "Contact CORE Strategies PT | Overland Park, KS",
    description: "Call 913-322-4000, send a general inquiry, or get directions to CORE Strategies PT at 10400 W 103rd St #22 in Overland Park, Kansas.",
    canonicalPath: "/contact",
  },
  "/inquiry": {
    title: "Request a Call | CORE Strategies PT",
    description: "Send a general inquiry to CORE Strategies PT. Share your contact information and an optional comment, and the Overland Park office will follow up.",
    canonicalPath: "/inquiry",
    noindex: true,
  },
  "/vitality-inquiry": {
    title: "Ask About Vitality Classes | CORE Strategies PT",
    description: "Ask about Vitality fitness classes for adults 50+ in Overland Park. Share four contact details and the CORE office will call with class information.",
    canonicalPath: "/vitality-inquiry",
    noindex: true,
    ogImage: "/manus-storage/vitality-adventure_a115d08b.webp",
    ogImageWidth: 1400,
    ogImageHeight: 1100,
    ogImageAlt: "Two active adults hiking together and looking toward the trail ahead",
  },
  "/privacy": {
    title: "Privacy Policy | CORE Strategies PT",
    description: "Learn how the CORE Strategies PT website handles inquiry information, analytics, CRM processing, retention, security, and privacy choices.",
    canonicalPath: "/privacy",
  },
  "/terms": {
    title: "Website Terms & Conditions | CORE Strategies PT",
    description: "Review the terms governing use of the CORE Strategies PT public website and its educational materials.",
    canonicalPath: "/terms",
  },
  "/disclaimer": {
    title: "Health Information Disclaimer | CORE Strategies PT",
    description: "Understand the limits of general health, movement, fitness, and rehabilitation information published by CORE Strategies PT.",
    canonicalPath: "/disclaimer",
  },
  "/accessibility": {
    title: "Accessibility Statement | CORE Strategies PT",
    description: "Read CORE Strategies PT's commitment to an accessible website and learn how to request assistance or report a digital barrier.",
    canonicalPath: "/accessibility",
  },
};
